module.exports = __webpack_public_path__ + "img/checkmark.54738b2e.svg";